import { analyzeGraph, Edge } from 'graph-cycles';
import { Person } from 'types';

interface PersonWithIdAndManagerIds extends Person {
  id: number;
  manager: Person | null;
  parentIds: Array<number>;
}

export const getCyclicPersonIdsToReRoot = (
  personIdToManagerIdMap: Record<string, string>,
  peopleDict: Record<string, { title?: string | null }>
): Set<string> => {
  const edges: Edge[] = Object.entries(personIdToManagerIdMap).map(
    ([personId, managerId]) => [personId, [managerId]]
  );
  const { cycles } = analyzeGraph(edges);

  const idsToReRoot = new Set<string>();
  cycles.forEach((cycle) => {
    const ceoId = cycle.find((id) => peopleDict[id]?.title === 'CEO');
    idsToReRoot.add(
      ceoId ?? [...cycle].sort((a, b) => Number(a) - Number(b))[0]
    );
  });
  return idsToReRoot;
};

// takes a list of people with managers inside and
// returns a key-value pair of person id to manager id
// as strings
export const getPersonIdToManagerIdMap = (
  peopleWithValidManagersOrNoManager: Array<PersonWithIdAndManagerIds>
): Record<string, string> => {
  return peopleWithValidManagersOrNoManager.reduce(
    (acc, p) => {
      if (p.manager?.id) {
        acc[p.id.toString()] = p.manager.id.toString();
      }
      return acc;
    },
    {} as Record<string, string>
  );
};
